export default "__VITE_ASSET__CU$krIuU__"